import gql from 'graphql-tag'

export const currentBookPref = gql`
  query currentBookPref($userId: ID!, $isCurrent: Boolean!) {
    allBookPrefs(
      filter: { AND: [{ user: { id: $userId } }, { isCurrent: $isCurrent }] }
    ) {
      id
      maxPage
      percentRead
      book {
        id
        name
        author
        totalPages
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/bookPref.js